import React, { useState } from 'react';
import { authAPI } from '../api';
import {
  validateUsername,
  validateEmail,
  validatePassword,
  validateTruckName,
  validateDescription,
  validateInstagramHandle
} from '../utils/validation';

function AuthModal({ onLogin, onClose }) {
  const [isLogin, setIsLogin] = useState(true);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    username: '',
    truck_name: '',
    description: '',
    instagram: '',
    registration_code: '',
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Validate input on frontend before sending to server
      if (!isLogin) {
        const usernameValidation = validateUsername(formData.username);
        if (!usernameValidation.isValid) {
          setError(usernameValidation.error);
          setLoading(false);
          return;
        }
        
        const truckNameValidation = validateTruckName(formData.truck_name);
        if (!truckNameValidation.isValid) {
          setError(truckNameValidation.error);
          setLoading(false);
          return;
        }
        
        const descriptionValidation = validateDescription(formData.description);
        if (!descriptionValidation.isValid) {
          setError(descriptionValidation.error);
          setLoading(false);
          return;
        }
        
        const instagramValidation = validateInstagramHandle(formData.instagram);
        if (!instagramValidation.isValid) {
          setError(instagramValidation.error);
          setLoading(false);
          return;
        }
      }
      
      const emailValidation = validateEmail(formData.email);
      if (!emailValidation.isValid) {
        setError(emailValidation.error);
        setLoading(false);
        return;
      }
      
      const passwordValidation = validatePassword(formData.password);
      if (!passwordValidation.isValid) {
        setError(passwordValidation.error);
        setLoading(false);
        return;
      }

      if (isLogin) {
        const res = await authAPI.login(emailValidation.value, passwordValidation.value);
        onLogin(res.data.user, res.data.token);
      } else {
        const sanitizedFormData = {
          ...formData,
          username: validateUsername(formData.username).value,
          email: emailValidation.value,
          password: passwordValidation.value,
          truck_name: validateTruckName(formData.truck_name).value,
          description: validateDescription(formData.description).value,
          instagram: validateInstagramHandle(formData.instagram).value
        };
        const res = await authAPI.register(sanitizedFormData);
        onLogin(res.data.user, res.data.token);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="auth-overlay" onClick={onClose}>
      <div className="auth-modal-wrapper" onClick={(e) => e.stopPropagation()}>
        <div className="auth-modal">
          <h2>{isLogin ? '🚚 Welcome Back!' : '🚚 Join AVL Flavor'}</h2>

          {error && <div className="error-message">{error}</div>}

          <form onSubmit={handleSubmit}>
            {!isLogin && (
              <>
                <div className="form-notice">
                  <strong>🔐 Registration Code Required</strong>
                  <p>Contact AVL Flavor to obtain your food truck registration code.</p>
                </div>
                <input
                  type="text"
                  name="registration_code"
                  placeholder="Registration Code *"
                  value={formData.registration_code}
                  onChange={handleChange}
                  required
                />
                <input
                  type="text"
                  name="username"
                  placeholder="Username *"
                  value={formData.username}
                  onChange={handleChange}
                  required
                />
                <input
                  type="text"
                  name="truck_name"
                  placeholder="Food Truck Name"
                  value={formData.truck_name}
                  onChange={handleChange}
                />
                <input
                  type="text"
                  name="instagram"
                  placeholder="Instagram Handle (e.g. @yourfoodtruck) *"
                  value={formData.instagram}
                  onChange={handleChange}
                  required
                />
                <input
                  type="text"
                  name="description"
                  placeholder="Short description of your truck"
                  value={formData.description}
                  onChange={handleChange}
                />
              </>
            )}

            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              required
              minLength={6}
            />

            <button type="submit" disabled={loading}>
              {loading ? 'Please wait...' : isLogin ? 'Login' : 'Sign Up'}
            </button>
          </form>

          <div className="toggle-auth">
            {isLogin ? (
              <p>
                Don't have an account?{' '}
                <button onClick={() => setIsLogin(false)}>Sign Up</button>
              </p>
            ) : (
              <p>
                Already have an account?{' '}
                <button onClick={() => setIsLogin(true)}>Login</button>
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AuthModal;
